export const getTrafficCamsSchema = {
    'lastUpdatedDateUtc': 'luu',
    'lastUpdatedDateUtcStr': 'luus',
    'cameras[]': {
        'disabled': 'd',
        'jumboImageUrl': 'jiu',
        'jumboImageUrlCache': 'jiuc',
        'largeImageUrl': 'liu',
        'largeImageUrlCache': 'liuc',
        'latitude': 'lat',
        'longitude': 'lon',
        'name': 'n',
        'smallImageUrl': 'siu',
        'smallImageUrlCache': 'siuc',
        'cameraId': 'ci',
        'distance': 'di',
        'hasStreamingVideo': 'hsv',
        'streams': 'ss',
        'orientation': 'o',
        'providerName': 'pn',
        'objectMapperKey': 'cs'
    }
};
